import { FC, useRef } from "react";
import { MuteButton } from "../../atoms";

import { SlotMachineChosenCardHolder, SlotMachineHeader, SlotMachineNotification, SlotMachineSpinner } from "../../molecules";
import { SlotMachineRefObject } from "../../molecules/SlotMachine/SlotMachineChosenCardHolder";

const SlotMachine: FC<{}> = () => {
    let slotMachineRef = useRef<SlotMachineRefObject>(null);

    return (
        <div className="slot">
            <MuteButton />
            <SlotMachineHeader /> 
            <SlotMachineNotification />
            <SlotMachineSpinner slotMachineRef={slotMachineRef} />
            <SlotMachineChosenCardHolder ref={slotMachineRef} />
        </div>

    );
};

export default SlotMachine;

